import { useEffect, useRef } from 'react'

/**
 * Hook to execute an async function exactly once when conditions are met
 * @param callback The async function to execute
 * @param condition Optional condition that must be true for execution (defaults to true)
 */
export const useExecuteOnce = (callback: () => Promise<void> | void, condition = true) => {
  const hasExecuted = useRef(false)

  useEffect(() => {
    const execute = async () => {
      if (!hasExecuted.current && condition) {
        hasExecuted.current = true
        await callback()
      }
    }

    execute()
  }, [callback, condition])
}
